// extracted by mini-css-extract-plugin
export default {"table":"memebrs-table_table__Weij5"};